import { isAdhocMetricSimple, QueryFormMetric } from './types';

export default function getColumnName(metric: QueryFormMetric): any  {
    if (typeof metric !== 'string' && isAdhocMetricSimple(metric)) {
        return `(${
            metric.column.columnName || metric.column.column_name
          })`;
    }
    return "";
}
  